import React from "react";
import actionaid from "../Assets/Images/actionaid.jpg";
import climate from "../Assets/Images/climate.jpg";
import isiolo from "../Assets/Images/isiolologo.jpg";
import ksg from "../Assets/Images/ksg-logo.png";
import activista from "../Assets/Images/activista.jpg";
import isiolotv from "../Assets/Images/isiolotv.png";
import kfcb from "../Assets/Images/kfcblogo.png";


function Partners() {
  const partners = [
  { name: 'actionaid', logo: actionaid },
  { name: 'mmck', logo: climate },
  { name: 'isiolo', logo: isiolo },
  { name: 'ksg', logo: ksg },
  { name: 'activista', logo: activista },
  { name: 'isiolotv', logo: isiolotv },
  { name: 'kfcb', logo: kfcb },
];
  return (
   
    <section id="partners" className="section-container bg-white relative overflow-hidden">
      <div className="relative mb-12">
        <div className="text-center mb-12">
          <div className="text-xl md:text-2xl font-bold text-red-500 mb-6 inline-block border-b-4 border-red-500">
            Our Partners
          </div>
        </div>

        {/* Infinite Slider */}
        <div className="relative">
          {/* Gradient Overlays */}
          {/* <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10"></div> */}

          {/* Slider Container */}
          <div className="overflow-hidden">
            <div className="flex animate-scroll">
              {/* First set of logos */}
              {partners.map((partner, index) => (
                <div
                  key={`first-${index}`}
                  className="flex-shrink-0 mx-6 group"
                >
                  <div className="w-40 h-32 bg-white rounded-xl border-2 border-surfaceDark hover:border-red-500 transition-all duration-300 flex items-center justify-center p-4 group-hover:shadow-xl">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="max-w-full max-h-full object-contain transition-all duration-300 ease-im-out"
                    />
                  </div>
                </div>
              ))}
              {/* Duplicate set for seamless loop */}
              {partners.map((partner, index) => (
                <div
                  key={`second-${index}`}
                  className="flex-shrink-0 mx-6 group"
                >
                  <div className="w-40 h-32 bg-white rounded-xl border-2 border-surfaceDark hover:border-accent transition-all duration-300 flex items-center justify-center p-6 group-hover:shadow-xl">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="max-w-full max-h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Partners;
